import getEventElement, {
  Options as GetElementOptions
} from './getEventElement';
import { Event } from '../constants';
import type { SetModalStatePayload } from '../contracts';

type Options = {
  /** Options to get the event element */
  getElementOptions?: GetElementOptions;
};

export default async function setModalState(
  modalId: string,
  isOpen: boolean,
  { getElementOptions }: Options = {}
): Promise<void> {
  const eventEl = await getEventElement(getElementOptions);

  eventEl?.dispatchEvent(
    new CustomEvent<SetModalStatePayload>(Event.SetModalState, {
      detail: { modalId, isOpen }
    })
  );
}
